<script>
	import Painel from './Painel.svelte';

	const opcoes = [
		{
			titulo: "Voltar", 
			icone: "voltar",
			link: "#/painel",
			perfis: "CETREINA,AVALIADOR,DISCENTE,COORDENADOR"
		},
		{
			titulo: "Limpar cache",
			icone: "refresh",
			link: `#/limpeza-aplicacao/${Math.random()}?m=${window.btoa(unescape(encodeURIComponent("Limpando cache, aguarde ...")))}`,
			perfis: "CETREINA,AVALIADOR,DISCENTE,COORDENADOR"
		},
		{ 
			titulo: "Globais", 
			icone: "servidor",
			link: "#/painel/configuracoes/back-end",
			perfis: "CETREINA"
		},
		{ 
			titulo: "Locais", 
			icone: "computador",
			link: "#/painel/configuracoes/front-end",
			perfis: "CETREINA,AVALIADOR"
		}
	];
</script>

<Painel 
	titulo="Configurações do Sistema" 
	listaFuncionalidades={opcoes}>
</Painel>
